import modal from '../patterns/modal.js';
import PL_utils from '../patterns/pl-utils.js';
import Player from '@vimeo/player'; 

const body = document.querySelector('body');

/**
 * ISI modal
 */
export const modalHooks = {
  _hasScrolledToBottom: false,
  _continueClicked: false, 
  _cancelClicked: false, 

  beforeOpen: function (target) {
    PL_utils.addClass('modal-open', body);
    this._hasScrolledToBottom = false;  
    this._continueClicked = false;      
    this._cancelClicked = false;        
    disableContinueButton();            
    const modalContent = target.querySelector('.modal__body .wrapper');
    if (modalContent) {
      modalContent.scrollTop = 0;  
    }
  },
  

  afterOpen: function (target) {
    const modalContent = target.querySelector('.modal__body .wrapper');
    if (modalContent) {
      modalContent.scrollTop = 0;  
      modalContent.addEventListener('scroll', function () {
        if (modalContent.scrollHeight - modalContent.scrollTop <= modalContent.clientHeight + 1) {
          modalHooks._hasScrolledToBottom = true;
          enableContinueButton();
        }
      });
    } else {
      console.error('Modal content not found');
    }
    target.focus();
  },

  onContinue: function () {
    if (this._hasScrolledToBottom) {
      this._continueClicked = true;
      hasModalShown = true;
      
      isiModal.hideModal();
      if (typeof this.onContinueCallback === 'function') {
        this.onContinueCallback();
      }
    }
  },

  onCancel: function () {
    this._cancelClicked = true;
    currentVideoTrigger = null;
    const activeVideoModals = document.querySelectorAll('.modal-video.active');
    activeVideoModals.forEach(videoModal => {
      const modalInstance = modal.initModal(videoModal, modalHooks, modalOpts);
      if (modalInstance) {
        modalInstance.hideModal();
      }
    });
  },

  afterClose: function () {
    PL_utils.removeClass('modal-open', body);
    if (!this._continueClicked) {
      currentVideoTrigger = null;
      const activeVideoModals = document.querySelectorAll('.modal-video.active');
      activeVideoModals.forEach(videoModal => {
        const modalInstance = modal.initModal(videoModal, modalHooks, modalOpts);
        if (modalInstance) {
          modalInstance.hideModal();
        }
      });
    }
  }
};

const modalOpts = {
  enableBackdropClose: true
};

const isiModalEle = document.querySelector('.modal-isi');
const isiModal = modal.initModal(isiModalEle, modalHooks, modalOpts);
const isiModalCloseTriggers = isiModalEle.querySelectorAll('.modal__close');
const isiModalCancel = isiModalEle.querySelector('.modal__cancel'); 
const vimeoElements = document.querySelectorAll('.vimeo-player');
const vimeoButtons = document.querySelectorAll('.vimeo-button');
const videoTranscripts = document.querySelectorAll('.video-transcript a');
const externalLinks = isiModalEle.querySelectorAll('[data-external-alt], [data-external]');
const videoTriggers = document.querySelectorAll('.video-trigger');

let videoPlayers = [];
let hasPlayed = [];
let currentVideoPlayer = null;
let currentVideoButton = null;
export let hasModalShown = false;
let currentTranscriptLink = null;
let currentVideoTrigger = null;

vimeoElements.forEach((vimeoElement, index) => {
  const videoId = vimeoElement.getAttribute('data-vimeo-id');
  const videoPlayer = new Player(vimeoElement, { id: videoId });
  const vimeoButton = vimeoButtons[index];

  videoPlayers.push(videoPlayer);
  hasPlayed.push(false);

  vimeoButton.addEventListener('click', function () {
    currentVideoPlayer = videoPlayer;
    currentVideoButton = vimeoButton;
    currentTranscriptLink = null;

    if (!hasModalShown) {
      isiModal.showModal();
      videoPlayer.getPaused().then((paused) => {
        if (!paused) {
          videoPlayer.pause();
        }
      });
    } else {
      videoPlayer.getPaused().then((paused) => {
        if (paused) {
          videoPlayer.play();
        }
      });
    }

    vimeoButton.style.display = 'none';
  });

  videoPlayer.on('pause', function () {
    vimeoButton.style.display = 'block';
  });

  videoPlayer.on('error', function (error) {
    console.error('Vimeo player error:', error);
  });
});

function closeModalAndPlayVideo() {
  console.log('Closing modal and playing video');
  isiModal.hideModal();

  if (modalHooks._continueClicked && currentVideoPlayer) {
    currentVideoPlayer.getPaused().then((paused) => {
      if (paused) {
        currentVideoPlayer.play().then(() => {
          currentVideoButton.style.display = 'none';
        });
      }
      hasPlayed[videoPlayers.indexOf(currentVideoPlayer)] = true;
    });
  }
}

function closeModalAndPauseVideo() {
  console.log('Closing modal and keeping video paused');
  isiModal.hideModal();
  if (currentVideoPlayer) {
    currentVideoPlayer.pause();
    currentVideoButton.style.display = 'block'; 
  }
}

isiModalCancel.addEventListener('click', function () {
  modalHooks.onCancel();
});

function enableContinueButton() {
  const continueButton = isiModalEle.querySelector('.modal__continue');
  if (continueButton) {
    continueButton.disabled = false;
    continueButton.classList.remove('disabled');
  }
}

function disableContinueButton() {
  const continueButton = isiModalEle.querySelector('.modal__continue');
  if (continueButton) {
    continueButton.disabled = true;
    continueButton.classList.add('disabled');
  }
}

const applyAccessibility = (ModalEle) => {
  const el_label = ModalEle.querySelector("[data-label]");
  if (el_label) {
    ModalEle.setAttribute("aria-label", el_label.innerHTML);
    ModalEle.setAttribute("role", "dialog");
    ModalEle.setAttribute("aria-modal", "true");
    ModalEle.removeAttribute("hidden");
    ModalEle.removeAttribute("aria-hidden");
    ModalEle.setAttribute("tabIndex", "0");
  }
};

export default () => {
  if (window.location.href.indexOf('ed=1') > -1) {
    if (window.location.search.substring(1).split('&').indexOf('modal=isi') > -1) {
      applyAccessibility(isiModalEle);
      isiModal.showModal();
      isiModalEle.focus();
    }
  }

  externalLinks.forEach(link => {
    link.addEventListener('click', () => {
      isiModal.hideModal();
    });
  });

  videoTranscripts.forEach((transcriptLink) => {
    transcriptLink.addEventListener('click', function (e) {
      e.preventDefault();
      currentTranscriptLink = this;
      currentVideoPlayer = null;
      currentVideoButton = null;
      const showIsiModal = this.dataset.showIsiModal;

      if (!hasModalShown && showIsiModal !== 'false') {
        modalHooks.onContinueCallback = () => {
          window.open(this.href, '_blank');
        };
        applyAccessibility(isiModalEle);
        isiModal.showModal();
        isiModalEle.focus();
      } else {
        window.open(this.href, '_blank');
      }
    });
  });
};